import { Component, Input } from '@angular/core';

@Component({
  selector: 'vc-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  // to use when loader is not fullscreen
  @Input() floating: boolean;
}
